// @flow

import gql from 'graphql-tag';
import { get } from 'lodash';

import { useQuery } from '@apollo/react-hooks';

type Input = {
  accountId: number,
  planId: ?string | number,
};

type Output = {
  error: ?string,
  invoice: any,
  isLoading: boolean,
};

export const invoicePreviewQuery = gql`
  query invoicePreviewQuery($accountId: Int!, $planId: ID) {
    account(id: $accountId) {
      id
      invoicePreview(planId: $planId) {
        amountDue
        id
        items {
          amount
          description
          id
        }
        periodEnd
        startingBalance
        total
      }
    }
  }
`;

const useInvoicePreview = ({ accountId, planId }: Input): Output => {
  const queryResults = useQuery(invoicePreviewQuery, {
    skip: !accountId || !planId,
    variables: {
      accountId,
      planId,
    },
  });

  return {
    error: queryResults.error
      ? 'There was an issue loading your invoice preview. Please try again'
      : null,
    invoice: get(queryResults, ['data', 'account', 'invoicePreview']),
    isLoading: queryResults.loading,
  };
};

export default useInvoicePreview;
